<template>
  <div id="app">
    <router-view></router-view>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppFooter from './pages/layout/Footer.vue'

export default {
  name: 'app',
  components: {
    AppFooter
  }
}
</script>

<style>
section.container {
  margin: 60px auto;
}
</style>



// WEBPACK FOOTER //
// App.vue?c20ea520